import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import './index.css';

// Supprimer les erreurs des extensions de navigateur de la console
// Ces erreurs "runtime.lastError" sont causées par des extensions qui tentent
// d'injecter du code et ne sont pas critiques pour l'application
if (typeof window !== 'undefined') {
  // Intercepter et ignorer les erreurs runtime.lastError des extensions
  const originalError = console.error;
  console.error = function(...args) {
    // Ignorer uniquement les erreurs spécifiques des extensions de navigateur
    const errorMessage = args.length > 0 ? String(args[0]) : '';
    if (errorMessage.includes('runtime.lastError') || 
        errorMessage.includes('Could not establish connection. Receiving end does not exist')) {
      return; // Ignorer silencieusement ces erreurs d'extensions
    }
    originalError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

